module.exports = __webpack_public_path__ + "img/marketing.9d0cf67a.svg";